import React from "react";
import { Link } from 'react-router-dom'
import { ExitStatus } from "typescript";
import errorStatus from "../assets/Error.png";
import errorStatus2 from "../assets/Error2.png";
import "../App.css";
import "../login.css";

// the login form will display if there is no session token stored.  This will display
// the login form, and call the API to authenticate the user and store the token in
// the session.

export default class LoginForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      alanmessage: "",
      sessiontoken: "",
      generalError: false,
      errorUsername: false,
      errorPassword: false,
      genout: "",
    };
    this.refreshPostsFromLogin = this.refreshPostsFromLogin.bind(this);
  }

  // once a user has successfully logged in, we want to refresh the post
  // listing that is displayed.  To do that, we'll call the callback passed in
  // from the parent.
  refreshPostsFromLogin() {
    console.log("CALLING LOGIN IN LOGINFORM");
    this.props.login();
  }

  // change handlers keep the state current with the values as you type them, so
  // the submit handler can read from the state to hit the API layer
  myChangeHandler = event => {
    this.setState({
      username: event.target.value
    });
  };

  passwordChangeHandler = event => {
    this.setState({
      password: event.target.value
    });
  };

  // when the user hits submit, process the login through the API
  submitHandler = event => {
    //keep the form from actually submitting
    event.preventDefault();

    //make the api call to the authentication page
    //Check if both username and password are empty
    if (this.state.username === "" && this.state.password === "") {
      this.setState({
        errorUsername: true,
        errorPassword: true,
      });
      return;
    } else {
      this.setState({
        errorUsername: false,
        errorPassword: false,
      });
    }
    //Error empty username
    if (this.state.username === "") {
      this.setState({
        errorUsername: true
      });
      this.forceUpdate();
      return;
    } else {
      this.setState({
        errorUsername: false
      });
    }

    // Error empty password
    if (this.state.password === "") {
      this.setState({
        errorPassword: true,
      });
      return;
    } else {
      this.setState({
        errorPassword: false,
      })
    }

    fetch(process.env.REACT_APP_API_PATH + "/auth/login", {
      method: "post",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: this.state.username,
        password: this.state.password
      })
    })
      .then(res => {
        console.log("We are here");
        console.log(res.ok);
        if (!res.ok) {
          console.log("This should exit");
          this.setState({
            generalError: true,
            genout: "Invalid email or password!",
          })
          return
        }

        return res.json();
      })
      .then(
        result => {



          console.log("Testing");
          if (result.userID) {

            // set the auth token and user ID in the session state
            sessionStorage.setItem("token", result.token);
            sessionStorage.setItem("user", result.userID);

            this.setState({
              sessiontoken: result.token,
              alanmessage: result.token
            });

            // call refresh on the posting list
            this.refreshPostsFromLogin();
          } else {

            // if the login failed, remove any infomation from the session state
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("user");
            this.setState({
              sessiontoken: "",
              alanmessage: result.message
            });
          }
        });

    // If we get here with no more errors we are good!
    this.setstate({
      generalError: false,
      errorUsername: false,
      errorPassword: false,
      genout: "",
    });
    return;
  };

  render() {
    // console.log("Rendering login, token is " + sessionStorage.getItem("token"));

    if (!sessionStorage.getItem("token")) {
      return (
        <form onSubmit={this.submitHandler} className="loginform">
          <div class="logincontainer">

            <div class="titlebox">
              <p class="logintitle">Log In</p>
            </div>
            {this.state.generalError ? <div className="generalloginfield"> <img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /> <div class="errorText">{this.state.genout}</div></div> : ""}
            <div class="usernamebox">
              <label for="log-usernamefield">Email</label>
              <input placeholder="E-mail" className={this.state.errorUsername ? "bloginfield" : "loginfield"} id="log-usernamefield" type="text" onChange={this.myChangeHandler} />
            </div>
            {this.state.errorUsername ? <div className="errorloginfield"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">Invalid Email</div></div> : ""}


            <div class="passwordbox">
              <label for="log-passwordfield">Password</label>
              <input className={this.state.errorPassword ? "bloginfield" : "loginfield"} id="log-passwordfield" type="password" onChange={this.passwordChangeHandler} />
              <p id="log-forgotpassword"><Link to="/forgotpassword">Forgot Password?</Link></p>
              {this.state.errorPassword ? <div className="errorloginfieldpass"><img height = "20px" class = "errorStatus" alt = "Error" src = {errorStatus2} /><div class="errorText">Invalid Password</div></div> : ""}
            </div>

            <div class="rememberbox">
              <label className="rememberme">
                <input type="checkbox" className="remembermebutton" id="log-remembercheck" /> Remember Me
              </label>
            </div>

            <div class="submissionbox">
              <input type="submit" value="Login" className="loginbutton" />
              <input type="submit" value="Cancel" className="cancelbutton" />
            </div>

            <div class="registermsgbox">
              <p id="log-signupMessage">Don't have an account? <Link to="/register">Sign Up!</Link></p>
            </div>

          </div>
          <p>{this.state.alanmessage}</p>
        </form>
      );
    } else {
      console.log("Returning welcome message");
      if (this.state.username) {
        return <p>Welcome, {this.state.username}</p>;
      } else {
        return <p>{this.state.alanmessage}</p>;
      }
    }
  }
}
